module.exports = "<p class=\"text\">{{text}}</p>\n"